// administrative, training, team meeting, brief
export const administrativeStatuses = [5, 11, 12, 13];

// launch, other, private
export const breakStatuses = [3, 7, 9];

export const LOGOUT_STATUS = 2;

export const LOGIN_STATUS = 1;

